var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_7075373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Code_x2C__coding_x2C__mobile_x2C__development"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1809_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1832_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.1303 9.06345H30.8345C30.2552 9.06345 29.7852 8.59336 29.7852 8.01415C29.7852 7.43493 30.2552 6.96484 30.8345 6.96484H37.1303C37.7095 6.96484 38.1796 7.43493 38.1796 8.01415C38.1796 8.59336 37.7095 9.06345 37.1303 9.06345Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1831_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45.5245 65.726H22.4399C19.5459 65.726 17.1934 63.3714 17.1934 60.4795V24.8032C17.1934 24.224 17.6634 23.7539 18.2427 23.7539C18.8219 23.7539 19.292 24.224 19.292 24.8032V60.4795C19.292 62.2151 20.7043 63.6274 22.4399 63.6274H45.5245C47.2601 63.6274 48.6724 62.2151 48.6724 60.4795V24.8032C48.6724 24.224 49.1425 23.7539 49.7217 23.7539C50.301 23.7539 50.771 24.224 50.771 24.8032V60.4795C50.771 63.3714 48.4185 65.726 45.5245 65.726Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1830_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M49.7217 32.15C49.1425 32.15 48.6724 31.6799 48.6724 31.1007V8.01605C48.6724 6.2805 47.2601 4.86814 45.5245 4.86814H22.4399C20.7043 4.86814 19.292 6.2805 19.292 8.01605V31.1007C19.292 31.6799 18.8219 32.15 18.2427 32.15C17.6634 32.15 17.1934 31.6799 17.1934 31.1007V8.01605C17.1934 5.12417 19.5459 2.76953 22.4399 2.76953H45.5245C48.4185 2.76953 50.771 5.12417 50.771 8.01605V31.1007C50.771 31.6799 50.301 32.15 49.7217 32.15Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1816_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1824_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M56.0171 13.3676C55.4379 13.3676 54.9678 13.0024 54.9678 12.4232V12.2134C54.9678 11.6342 55.4379 11.1641 56.0171 11.1641C56.5963 11.1641 57.0664 11.6342 57.0664 12.2134C57.0664 12.7926 56.5963 13.3676 56.0171 13.3676Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1818_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M56.0171 17.5629C55.4379 17.5629 54.9678 17.1978 54.9678 16.6185V16.4087C54.9678 15.8295 55.4379 15.3594 56.0171 15.3594C56.5963 15.3594 57.0664 15.8295 57.0664 16.4087C57.0664 16.9879 56.5963 17.5629 56.0171 17.5629Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1817_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M56.0171 21.7621C55.4379 21.7621 54.9678 21.397 54.9678 20.8178V20.6079C54.9678 20.0287 55.4379 19.5586 56.0171 19.5586C56.5963 19.5586 57.0664 20.0287 57.0664 20.6079C57.0664 21.1871 56.5963 21.7621 56.0171 21.7621Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1820_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1823_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.9468 48.8324C11.3675 48.8324 10.8975 48.4673 10.8975 47.8881V47.6782C10.8975 47.099 11.3675 46.6289 11.9468 46.6289C12.526 46.6289 12.9961 47.099 12.9961 47.6782C12.9961 48.2574 12.526 48.8324 11.9468 48.8324Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1822_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M11.9468 53.0278C11.3675 53.0278 10.8975 52.6626 10.8975 52.0834V51.8735C10.8975 51.2943 11.3675 50.8242 11.9468 50.8242C12.526 50.8242 12.9961 51.2943 12.9961 51.8735C12.9961 52.4527 12.526 53.0278 11.9468 53.0278Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1821_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.9468 57.227C11.3675 57.227 10.8975 56.8618 10.8975 56.2826V56.0727C10.8975 55.4935 11.3675 55.0234 11.9468 55.0234C12.526 55.0234 12.9961 55.4935 12.9961 56.0727C12.9961 56.652 12.526 57.227 11.9468 57.227Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1815_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M52.5359 57.3336C52.4625 57.3336 52.3869 57.3273 52.3135 57.3105C51.7468 57.1888 51.388 56.6306 51.5097 56.0639L52.2022 52.8531C52.2862 52.4585 52.5905 52.15 52.9808 52.0556C53.9714 51.8164 54.9367 51.4134 55.8496 50.8573C56.1875 50.6474 56.6219 50.6537 56.9598 50.8678L59.0374 52.1962L60.3238 50.8993L58.9954 48.8384C58.7772 48.5006 58.773 48.0662 58.9807 47.7241C59.5369 46.8112 59.9398 45.8458 60.1769 44.8553C60.2714 44.465 60.5778 44.1628 60.9702 44.0746L63.3626 43.5437V41.7452L60.9723 41.2142C60.5799 41.1261 60.2735 40.8239 60.179 40.4335C59.9419 39.443 59.5369 38.4776 58.9828 37.5647C58.773 37.2227 58.7772 36.7904 58.9954 36.4525L60.3259 34.3728L59.0416 33.0884L56.9619 34.4189C56.624 34.6351 56.1917 34.6393 55.8517 34.4294C54.9367 33.8733 53.9714 33.4704 52.9829 33.2311C52.5905 33.1367 52.2883 32.8261 52.2043 32.4336L51.6881 30.0517H50.771C50.1918 30.0517 49.7217 29.5816 49.7217 29.0024C49.7217 28.4232 50.1918 27.9531 50.771 27.9531H52.5338C53.027 27.9531 53.4551 28.2994 53.5579 28.7821L54.1183 31.3697C54.8863 31.6026 55.6397 31.9174 56.3659 32.3098L58.6198 30.8681C59.0353 30.6037 59.5767 30.6624 59.9272 31.0108L62.4057 33.4871C62.754 33.8355 62.8128 34.3791 62.5463 34.7946L61.1045 37.0485C61.497 37.7767 61.8117 38.5301 62.0447 39.3003L64.6365 39.8753C65.1191 39.9823 65.4612 40.4104 65.4612 40.9015V44.3852C65.4612 44.8763 65.1191 45.3044 64.6386 45.4093L62.0468 45.9843C61.8138 46.7545 61.4991 47.5079 61.1066 48.234L62.5463 50.467C62.8149 50.8804 62.7582 51.426 62.4098 51.7744L59.9314 54.2717C59.5809 54.6222 59.0374 54.681 58.6219 54.4165L56.368 52.9748C55.6397 53.3672 54.8884 53.682 54.1204 53.915L53.56 56.5026C53.453 56.9978 53.0165 57.3336 52.5359 57.3336Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1810_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M53.6901 48.0537C53.3543 48.0537 53.0227 47.89 52.8192 47.5899C52.496 47.1093 52.624 46.4566 53.1067 46.1335C54.2714 45.3486 54.9681 44.0432 54.9681 42.6435C54.9681 40.3287 53.0857 38.4463 50.7709 38.4463C50.4855 38.4463 50.2022 38.4756 49.9315 38.5302C49.3691 38.6435 48.8087 38.2826 48.6912 37.7117C48.5758 37.143 48.941 36.589 49.5097 36.4736C49.921 36.3917 50.3449 36.3477 50.7709 36.3477C54.242 36.3477 57.0668 39.1724 57.0668 42.6435C57.0668 44.7442 56.0237 46.7001 54.2735 47.8753C54.0951 47.9949 53.8916 48.0537 53.6901 48.0537Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1293_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M17.1933 32.1514C13.7222 32.1514 10.8975 29.3266 10.8975 25.8555C10.8975 23.7464 11.9468 21.7884 13.7054 20.6132C14.1818 20.2942 14.8365 20.4201 15.1597 20.9049C15.4808 21.3855 15.3507 22.0382 14.868 22.3593C13.697 23.1441 12.9961 24.4495 12.9961 25.8555C12.9961 28.1703 14.8785 30.0527 17.1933 30.0527C17.4745 30.0527 17.7515 30.0255 18.0159 29.9709C18.5721 29.8555 19.1366 30.2227 19.252 30.7936C19.3674 31.3623 18.9981 31.9142 18.4294 32.0275C18.0285 32.1094 17.6172 32.1514 17.1933 32.1514Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1811_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M17.1932 40.5444H15.4303C14.9372 40.5444 14.5091 40.1982 14.4062 39.7155L13.8459 37.1279C13.0778 36.8949 12.3244 36.5802 11.5983 36.1877L9.34438 37.6295C8.92676 37.8939 8.38742 37.8372 8.03695 37.4868L5.5585 35.0104C5.21013 34.662 5.15137 34.1185 5.41789 33.703L6.85963 31.4491C6.4672 30.7208 6.1524 29.9674 5.91946 29.1973L3.32768 28.6222C2.845 28.5152 2.50293 28.0871 2.50293 27.596V24.1123C2.50293 23.6213 2.845 23.1932 3.32558 23.0882L5.91736 22.5132C6.15031 21.743 6.4651 20.9896 6.85754 20.2635L5.41999 18.0285C5.15137 17.6151 5.20803 17.0694 5.5564 16.721L8.03485 14.2237C8.38112 13.8711 8.92676 13.8124 9.34438 14.0789L11.5983 15.5206C12.3265 15.1282 13.0778 14.8134 13.8459 14.5805L14.4062 11.9929C14.5279 11.4242 15.0967 11.0632 15.6528 11.1891C16.2194 11.3108 16.5783 11.8691 16.4566 12.4357L15.764 15.6466C15.6801 16.0411 15.3758 16.3496 14.9854 16.444C13.9949 16.6833 13.0295 17.0862 12.1145 17.6423C11.7746 17.8522 11.3423 17.8459 11.0044 17.6318L8.92676 16.3034L7.63822 17.6004L8.96663 19.6612C9.18699 19.9991 9.19119 20.4335 8.98133 20.7756C8.42519 21.6884 8.02226 22.6538 7.78512 23.6443C7.69068 24.0347 7.38429 24.3369 6.99185 24.425L4.60154 24.9539V26.7524L6.99185 27.2833C7.38429 27.3715 7.69068 27.6737 7.78512 28.064C8.02226 29.0546 8.42729 30.0199 8.98133 30.9328C9.19119 31.2749 9.18699 31.7072 8.96873 32.0451L7.63822 34.1227L8.92256 35.407L11.0023 34.0765C11.3402 33.8625 11.7746 33.8583 12.1124 34.066C13.0274 34.6222 13.9928 35.0251 14.9812 35.2643C15.3737 35.3588 15.6759 35.6694 15.7598 36.0618L16.2761 38.4458H17.1932C17.7724 38.4458 18.2425 38.9159 18.2425 39.4951C18.2425 40.0743 17.7724 40.5444 17.1932 40.5444Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1813_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1890_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M32.9323 39.4933C32.8484 39.4933 32.7645 39.4828 32.6784 39.4618C32.1139 39.3212 31.7739 38.7524 31.9145 38.19L34.0131 29.7956C34.1516 29.2311 34.712 28.8911 35.2849 29.0317C35.8494 29.1723 36.1894 29.741 36.0488 30.3035L33.9502 38.6979C33.8326 39.1764 33.4045 39.4933 32.9323 39.4933Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1888_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M39.2285 39.4915C38.9599 39.4915 38.6913 39.3886 38.4856 39.1851C38.0764 38.7758 38.0764 38.1106 38.4856 37.7013L41.942 34.2449L38.4877 30.7906C38.0785 30.3814 38.0785 29.7161 38.4877 29.3069C38.897 28.8977 39.5622 28.8977 39.9714 29.3069L44.1687 33.5041C44.5779 33.9134 44.5779 34.5786 44.1687 34.9878L39.9714 39.1851C39.7658 39.3886 39.4972 39.4915 39.2285 39.4915Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1887_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M28.7353 39.4915C28.4667 39.4915 28.1981 39.3886 27.9924 39.1851L23.7952 34.9878C23.386 34.5786 23.386 33.9134 23.7952 33.5041L27.9924 29.3069C28.4016 28.8977 29.0669 28.8977 29.4761 29.3069C29.8854 29.7161 29.8854 30.3814 29.4761 30.7906L26.0218 34.2449L29.4761 37.6992C29.8854 38.1085 29.8854 38.7737 29.4761 39.183C29.2726 39.3886 29.0039 39.4915 28.7353 39.4915Z",
    fill: "black"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.066ef2333a193b6a728edf2a32698a37.svg";
export { ForwardRef as ReactComponent };